import { useState, useEffect } from 'react';

/**
 * Custom hook untuk mengelola tema dark/light mode
 * Otomatis mendeteksi preferensi sistem pengguna
 */
export const useTheme = () => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // Deteksi preferensi sistem
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            setIsDarkMode(true);
        }
    }, []);

    const toggleTheme = () => setIsDarkMode(!isDarkMode);

    return { isDarkMode, toggleTheme, setIsDarkMode };
};
